@if (routerLink() !== undefined) {
  <a class="app-back-button" [routerLink]="routerLink()" data-testid="back-button-link">
    <svg
      class="app-back-button__icon"
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M13.281 6.78101L4.78099 15.281L4.09399 16L4.78099 16.719L13.281 25.219L14.719 23.781L7.93799 17H28V15H7.93699L14.719 8.21901L13.281 6.78101Z" fill="currentColor"/>
    </svg>
    {{ label() }}
  </a>
} @else {
  <button
    type="button"
    class="app-back-button"
    data-testid="back-button-btn"
    (click)="back.emit()"
  >
    <svg
      class="app-back-button__icon"
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M13.281 6.78101L4.78099 15.281L4.09399 16L4.78099 16.719L13.281 25.219L14.719 23.781L7.93799 17H28V15H7.93699L14.719 8.21901L13.281 6.78101Z" fill="currentColor"/>
    </svg>
    {{ label() }}
  </button>
}
